import React from 'react';
import { useOutletContext } from 'react-router';

import useRouterSteps from 'hooks/useRouterSteps';
import type PageBaseProps from 'types/PageBase';

import type { LoginStep } from './Steps';

export interface LoginOutletContext {
  steps: LoginStep[];
}

const LoginStepContent: React.FC = () => {
  const { steps } = useOutletContext<LoginOutletContext>();

  const {
    currentStep,
    next,
    previous,
  } = useRouterSteps<unknown, PageBaseProps>({ steps });

  const currentIndex = steps.findIndex(({ key }) => key === currentStep.key);

  const Component = React.useMemo(
    () => ('render' in currentStep ? currentStep.render : currentStep.component),
    [currentStep],
  );

  return (
    <Component
      onNext={next}
      onPrev={previous}
      shouldDisplayBackButton={currentIndex > 0}
    />
  );
};

export default LoginStepContent;
